import { CampaignType } from 'types/apollo/globalTypes';

/** Private: every caller goes through campaignTypeLabel so there is one lookup convention. */
const CAMPAIGN_TYPE_LABELS: Record<CampaignType, string> = {
  [CampaignType.CALL_CENTER_TRANSFER]: 'Transfer to a call center',
  [CampaignType.LINK_CLICK]: 'Get the lead to click a link',
  [CampaignType.APPOINTMENT_SCHEDULING]: 'Book an appointment',
};

/** Unrecognised values render as nothing rather than crashing the bell. */
export const campaignTypeLabel = (type: string | null): string | null =>
  type ? CAMPAIGN_TYPE_LABELS[type as CampaignType] ?? null : null;
